import styled from "styled-components"
import { Link } from "react-router-dom"




const Container = styled.div`
    width: 100vw;
    height: 100vh;
    background: linear-gradient(#ffffff1d, #ffffff3e), url("https://images.pexels.com/photos/8356406/pexels-photo-8356406.jpeg?cs=srgb&dl=pexels-marina-m-8356406.jpg&fm=jpg");
    background-size: cover;
    background-repeat: no-repeat;
    display: flex;
    align-items: center;
    justify-content: center;
`
const Wrapper = styled.div`
    padding: 8%;
    width: 40%;
    background-color: #241654a6;
    color: white;
`
const Title = styled.h1`
    font-size: 34px;
    font-weight: 600;
`
const Form = styled.form`
    display: flex;
    flex-wrap: wrap;
`
const Input = styled.input`
    flex: 1;
    min-width: 40%;
    margin: 20px 10px 0 0;
    padding: 10px;
` 
const Agreement = styled.p`
    font-size: 12px;
    margin: 20px 0;
`
const Button = styled.button`
    width: 40%;
    border: none;
    padding: 15px 20px;
    background-color: teal;
    color: white;
    cursor: pointer;
    font-weight: 500;
    margin-bottom: 30px;
    &:hover {
        background-color: #bff7bfcc;
        transform: scale(1.05);
        color: black;
    }
`
const Links = styled.a`
    font-size: 14px;
    text-decoration: underline;
    cursor: pointer;
`
const LinkStyle = {
    color: "white",
    textDecoration: "none"
}




const Register = () => {
    return (
        <Container>
            <Wrapper >
                <Title >Create account </Title>
                <Form>
                    <Input placeholder="name" />
                    <Input placeholder="last name" />
                    <Input placeholder="username" />
                    <Input placeholder="email" />
                    <Input placeholder="password" />
                    <Input placeholder="confirm password" />
                    <Agreement >
                        Lorem ipsum dolor, 
                        sit amet consectetur Lorem ipsum dolor sit, amet consectetur adipisicing elit. Tempore, laudantium? adipisicing elit. Praesentium, culpa.
                    </Agreement>
                    <Button >
                        Create
                    </Button>
                </Form>
                <Link to="/" style={LinkStyle} >
                        <Links > Go back home </Links>
                </Link>
            </Wrapper>
        </Container>
    )
}

export default Register
